export function CarIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      <path d="M5 17h14v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2z" />
      <path d="M16 17v-4H8v4" />
      <path d="M7 13L5.8 8.8a1 1 0 0 1 1-1.3h10.4a1 1 0 0 1 1 1.3L17 13" />
      <path d="M5 13h14" />
      <circle cx="7.5" cy="16" r="1" />
      <circle cx="16.5" cy="16" r="1" />
    </svg>
  )
}
